import React, { useState, Component } from 'react';
import { Twitter, Instagram } from 'lucide-react';
export const Footer = () => {
  const [email, setEmail] = useState('');
  const handleSubscribe = e => {
    e.preventDefault();
    if (email) {
      const subject = 'Newsletter Subscription';
      const body = `I would like to subscribe to the Niqqanno newsletter.\n\nEmail: ${email}`;
      const mailtoLink = `mailto:niqqannoconsult21@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      window.location.href = mailtoLink;
      setEmail('');
    }
  };
  return <footer className="bg-primary-dark text-white" data-id="element-132">
      <div className="container mx-auto px-4 py-12" data-id="element-133">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-134">
          {/* Company Info */}
          <div data-id="element-135">
            <h3 className="text-gold font-serif text-xl font-bold mb-6" data-id="element-136">
              Niqqanno
            </h3>
            <p className="text-gray-300 mb-6" data-id="element-137">
              Elevating businesses through strategic legal counsel and business
              expertise. Niqqanno Consulting is your partner in navigating
              complex business challenges.
            </p>
            <div className="flex space-x-4" data-id="element-138">
              <a href="https://x.com/NIQQANNO?t=SCaQAVYvmdJR-sFm2O3QXQ&s=09" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-gold transition-colors duration-300" data-id="element-139">
                <Twitter size={20} data-id="element-140" />
              </a>
              <a href="https://www.instagram.com/niqqanno_consulting?igsh=MWx3eWszdmpsdXNzbg==" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-gold transition-colors duration-300" data-id="element-141">
                <Instagram size={20} data-id="element-142" />
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-143">
            <h3 className="text-white font-bold mb-6" data-id="element-144">Quick Links</h3>
            <ul className="space-y-3" data-id="element-145">
              <li data-id="element-146">
                <a href="#about" className="text-gray-300 hover:text-gold transition-colors duration-300" data-id="element-147">
                  About Us
                </a>
              </li>
              <li data-id="element-148">
                <a href="#services" className="text-gray-300 hover:text-gold transition-colors duration-300" data-id="element-149">
                  Our Services
                </a>
              </li>
              <li data-id="element-150">
                <a href="#case-studies" className="text-gray-300 hover:text-gold transition-colors duration-300" data-id="element-151">
                  Case Studies
                </a>
              </li>
              <li data-id="element-152">
                <a href="#contact" className="text-gray-300 hover:text-gold transition-colors duration-300" data-id="element-153">
                  Contact Us
                </a>
              </li>
              <li data-id="element-154">
                <a href="#careers" className="text-gray-300 hover:text-gold transition-colors duration-300" data-id="element-155">
                  Careers
                </a>
              </li>
            </ul>
          </div>
          {/* Services */}
          <div data-id="element-156">
            <h3 className="text-white font-bold mb-6" data-id="element-157">Services</h3>
            <ul className="space-y-3" data-id="element-158">
              <li data-id="element-159">
                <a href="#corporate-law" className="text-gray-300 hover:text-gold transition-colors duration-300" data-id="element-160">
                  Corporate Law
                </a>
              </li>
              <li data-id="element-161">
                <a href="#business-strategy" className="text-gray-300 hover:text-gold transition-colors duration-300" data-id="element-162">
                  Business Strategy
                </a>
              </li>
              <li data-id="element-163">
                <a href="#mergers" className="text-gray-300 hover:text-gold transition-colors duration-300" data-id="element-164">
                  Mergers & Acquisitions
                </a>
              </li>
              <li data-id="element-165">
                <a href="#compliance" className="text-gray-300 hover:text-gold transition-colors duration-300" data-id="element-166">
                  Regulatory Compliance
                </a>
              </li>
              <li data-id="element-167">
                <a href="#ip" className="text-gray-300 hover:text-gold transition-colors duration-300" data-id="element-168">
                  Intellectual Property
                </a>
              </li>
            </ul>
          </div>
          {/* Newsletter */}
          <div data-id="element-169">
            <h3 className="text-white font-bold mb-6" data-id="element-170">Newsletter</h3>
            <p className="text-gray-300 mb-4" data-id="element-171">
              Subscribe to our newsletter for the latest insights and updates.
            </p>
            <form className="mb-4" onSubmit={handleSubscribe} data-id="element-172">
              <div className="flex" data-id="element-173">
                <input type="email" placeholder="Your email address" className="bg-primary border border-gray-600 text-white px-4 py-2 rounded-l-md focus:outline-none focus:border-gold w-full" value={email} onChange={e => setEmail(e.target.value)} required data-id="element-174" />
                <button type="submit" className="bg-gold text-primary-dark px-4 py-2 rounded-r-md hover:bg-gold-light transition-colors duration-300" data-id="element-175">
                  Subscribe
                </button>
              </div>
            </form>
            <p className="text-gray-400 text-sm" data-id="element-176">
              By subscribing, you agree to our Privacy Policy and consent to
              receive updates from our company.
            </p>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-8" data-id="element-177">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-178">
            <p className="text-gray-400 text-sm mb-4 md:mb-0" data-id="element-179">
              &copy; {new Date().getFullYear()} Niqqanno Consulting. All rights
              reserved.
            </p>
            <div className="flex space-x-6" data-id="element-180">
              <a href="#privacy" className="text-gray-400 text-sm hover:text-gold transition-colors duration-300" data-id="element-181">
                Privacy Policy
              </a>
              <a href="#terms" className="text-gray-400 text-sm hover:text-gold transition-colors duration-300" data-id="element-182">
                Terms of Service
              </a>
              <a href="#cookies" className="text-gray-400 text-sm hover:text-gold transition-colors duration-300" data-id="element-183">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};